import { createSelector } from '@reduxjs/toolkit';
import { eventOccurrencesNotDeleted } from '../events/event-occurrences-not-deleted';
import { today } from './today';
import { DayOfWeek, LocalDate } from '../../../utilities/local-date';

export const overdueEventOccurrences = createSelector(eventOccurrencesNotDeleted, today, (occurrences, today) => {
  const mondayThisWeek = LocalDate.fromString(today).withPreviousOrSame(DayOfWeek.MONDAY);

  return occurrences.filter(
    (e) => e.date !== null && e.persistent && !e.doneDate && LocalDate.fromString(e.date).isBefore(mondayThisWeek),
  );
});
